import React, { useEffect, useState } from "react";
import jazz from "../../assets/jazz.jpg";
import bluss from "../../assets/bluss.jfif";
import "../../Dashboard/pages/pages.css";
import api from "../../utilis/api";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const TeacherOverview = () => {
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [teacher, setTeacher] = useState(null);
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (!user._id) return;

      setLoading(true);
      try {
        // 1️⃣ Fetch teacher
        const teacherRes = await api.get(`/teacher/${user._id}`);
        const teacherData = teacherRes.data.data;
        setTeacher(teacherData);

        // 2️⃣ Fetch bookings using teacher._id
        const bookingRes = await api.get(
          `/booking?teacherId=${teacherData._id}`,
        );
        setBookings(bookingRes.data.data);
      } catch (err) {
        console.error("Dashboard fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user._id]);

  // ── Derived stats ──────────────────────────────────────
  const totalBookings = bookings.length;
  const confirmed = bookings.filter((b) => b.status === "confirmed");
  const pending = bookings.filter((b) => b.status === "pending");
  const completed = bookings.filter((b) => b.status === "completed");

  const uniqueStudents = new Set(
    bookings.map((b) => b.studentId?._id).filter(Boolean),
  ).size;

  const earnings = completed.reduce(
    (sum, b) => sum + (b.duration / 60) * (teacher?.hourlyRate || 0),
    0,
  );

  // Upcoming = confirmed sorted by date, latest 5
  const upcomingLessons = [...confirmed]
    .sort((a, b) => new Date(a.date) - new Date(b.date))
    .slice(0, 5);

  // Courses = derived from teacher skills (static images fallback)
  const courseImages = [jazz, bluss, jazz, bluss];
  const teacherCourses = (teacher?.skills || []).map((skill, i) => ({
    id: i + 1,
    title: skill,
    students: uniqueStudents,
    progress: Math.min(
      100,
      Math.round((completed.length / (totalBookings || 1)) * 100),
    ),
    image: courseImages[i % courseImages.length],
  }));

  const teacherStats = {
    totalBookings,
    earnings: `$${Math.round(earnings)}`,
    streak: `${completed.length} sessions done`,
    students: uniqueStudents,
    pending: pending.length,
  };

  const formatDate = (d) =>
    d
      ? new Date(d).toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
        })
      : "";

  const getStatusColor = (status) => {
    if (status === "confirmed") return "#22c55e";
    if (status === "pending") return "#f59e0b";
    if (status === "completed") return "#818cf8";
    return "#9ca3af";
  };

  if (loading) {
    return (
      <div className="overview-container">
        <header className="overview-header">
          <div className="header-text">
            <span className="header-subtitle">Loading...</span>
            <h1 className="header-title">Teacher Dashboard</h1>
          </div>
        </header>
        <div
          style={{ color: "var(--color-text-secondary)", padding: "2rem 0" }}
        >
          Fetching your data...
        </div>
      </div>
    );
  }

  return (
    <div className="overview-container">
      <header className="overview-header">
        <div className="header-text">
          <span className="header-subtitle">
            Welcome Back, {teacher?.userId?.name || user?.name || "Teacher"}
          </span>
          <h1 className="header-title">Teacher Dashboard</h1>
        </div>
        <div className="user-profile" />
      </header>

      {/* Top Stats Section */}
      <div
        className="dashboard-grid"
        style={{
          gridTemplateColumns: "repeat(auto-fit,minmax(180px,1fr))",
          gap: "1rem",
          marginBottom: "1rem",
        }}
      >
        <section className="card">
          <h3>Total Bookings</h3>
          <p style={{ fontSize: "1.5rem", fontWeight: 600 }}>
            {teacherStats.totalBookings}
          </p>
          <p
            style={{ fontSize: "0.75rem", color: "#f59e0b", marginTop: "4px" }}
          >
            {teacherStats.pending} pending
          </p>
        </section>

        {/* <section className="card">
          <h3>Earnings</h3>
          <p style={{ fontSize: "1.5rem", fontWeight: 600 }}>
            {teacherStats.earnings}
          </p>
          <p
            style={{ fontSize: "0.75rem", color: "#9ca3af", marginTop: "4px" }}
          >
            {completed.length} completed sessions
          </p>
        </section> */}

        <section className="card">
          <h3>Students</h3>
          <p style={{ fontSize: "1.5rem", fontWeight: 600 }}>
            {teacherStats.students}
          </p>
          <p
            style={{ fontSize: "0.75rem", color: "#9ca3af", marginTop: "4px" }}
          >
            Unique learners
          </p>
        </section>

        <section className="card">
          <h3>Sessions Done</h3>
          <p style={{ fontSize: "1.5rem", fontWeight: 600 }}>
            {completed.length}
          </p>
          <p
            style={{ fontSize: "0.75rem", color: "#22c55e", marginTop: "4px" }}
          >
            {confirmed.length} upcoming
          </p>
        </section>
      </div>

      {/* Courses You Teach */}
      {/* {teacherCourses.length > 0 && (
        <section className="card" style={{ marginBottom: "1rem" }}>
          <h3 style={{ marginBottom: "1rem" }}>Your Skills / Courses</h3>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
              gap: "12px",
            }}
          >
            {teacherCourses.map((course) => (
              <div
                key={course.id}
                style={{
                  borderRadius: "10px",
                  overflow: "hidden",
                  border: "0.5px solid var(--color-border-tertiary)",
                }}
              >
                <img
                  src={course.image}
                  alt={course.title}
                  style={{ width: "100%", height: "80px", objectFit: "cover" }}
                />
                <div style={{ padding: "10px" }}>
                  <div style={{ fontSize: "13px", fontWeight: 500, marginBottom: "6px" }}>
                    {course.title}
                  </div>
                  <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "6px" }}>
                    {course.students} students
                  </div>
                  <div
                    style={{
                      height: "3px",
                      background: "#1f2937",
                      borderRadius: "2px",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        width: `${course.progress}%`,
                        height: "100%",
                        background: "linear-gradient(90deg, #1a1a1a, #e6a435)",
                      }}
                    />
                  </div>
                  <div style={{ fontSize: "11px", color: "#e6a435", marginTop: "4px" }}>
                    {course.progress}% complete
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      )} */}

      {/* Upcoming Lessons */}
      <section className="card">
        <h3 style={{ marginBottom: "1rem" }}>Upcoming Sessions</h3>
        {upcomingLessons.length === 0 ? (
          <p style={{ fontSize: "13px", color: "#9ca3af" }}>
            No upcoming lessons
          </p>
        ) : (
          <table className="lessons-table">
            <thead>
              <tr>
                <th>Student</th>
                <th>Email</th>
                <th>Date</th>
                <th>Time</th>
                <th>Duration</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {upcomingLessons.map((b) => (
                <tr key={b._id}>
                  <td>{b.studentId?.name || "—"}</td>
                  <td style={{ fontSize: "12px", color: "#9ca3af" }}>
                    {b.studentId?.email || "—"}
                  </td>
                  <td>{formatDate(b.date)}</td>
                  <td>{b.time}</td>
                  <td>{b.duration} min</td>
                  <td
                    style={{ color: getStatusColor(b.status), fontWeight: 500 }}
                  >
                    {b.status.charAt(0).toUpperCase() + b.status.slice(1)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>

      {/* All Recent Bookings */}
      {bookings.length > 0 && (
        <section className="card" style={{ marginTop: "1rem" }}>
          <h3 style={{ marginBottom: "1rem" }}>Recent Bookings</h3>
          <table className="lessons-table">
            <thead>
              <tr>
                <th>Student</th>
                <th>Date</th>
                <th>Time</th>
                <th>Duration</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {[...bookings]
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .slice(0, 6)
                .map((b) => (
                  <tr key={b._id}>
                    <td>{b.studentId?.name || "—"}</td>
                    <td>{formatDate(b.date)}</td>
                    <td>{b.time}</td>
                    <td>{b.duration} min</td>
                    <td
                      style={{
                        color: getStatusColor(b.status),
                        fontWeight: 500,
                      }}
                    >
                      {b.status.charAt(0).toUpperCase() + b.status.slice(1)}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </section>
      )}

      {/* Quick Actions */}
      <section className="card" style={{ marginTop: "1rem" }}>
        <h3>Quick Actions</h3>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            flexWrap: "wrap",
            marginTop: "0.75rem",
          }}
        >
          <button
            onClick={() => navigate("/dashboard/teacher/availability")}
            className="dashboard-btn register-btn"
            style={{
              background: "linear-gradient(90deg, #1a1a1a, #e6a435)",
              border: "none",
            }}
          >
            Update Availability
          </button>
          <button
            onClick={() => navigate("/dashboard/teacher/profile")}
            className="dashboard-btn register-btn"
            style={{ background: "#1f2937" }}
          >
            Edit Profile
          </button>
          <button
            onClick={() => navigate("/dashboard/teacher/bookings")}
            className="dashboard-btn register-btn"
            style={{ background: "#1f2937" }}
          >
            View All Upcomming
          </button>
        </div>
      </section>
    </div>
  );
};

export default TeacherOverview;
